import React from "react";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";
//import InputMask from "react-input-mask";
import MaskedInput from 'react-text-mask'
import { connect } from "react-redux";
import moment from "moment";
import { creditCardvalidation, getCreditCardType } from "../../modules/utils";
import ReCAPTCHA from "react-google-recaptcha";
import TermsModal from "../../layout/TermsModal";

//const pattern = /^(0[1-9]|1[012])\/\d{4}$/; //MM/YYYY
const pattern = /^(0[1-9]|1[012])\/\d{2}$/; //MM/YY
function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.ccnumber)) {
    errors.ccnumber = "This field is required";
  }
  if (!creditCardvalidation(data.ccnumber)) {
    errors.ccnumber = "Enter valid card Number";
  }

  if (Validator.isEmpty(data.ccname)) {
    errors.ccname = "This field is required";
  }

  if (Validator.isEmpty(data.cvv)) {
    errors.cvv = "This field is required";
  }
  if (Validator.isEmpty(data.expiry)) {
    errors.expiry = "This field is required";
  }
  if (!pattern.test(data.expiry)) {
    errors.expiry = "Enter Expiry in valid format";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class PaymentMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cctype: "",
      ccnumber: "",
      ccname: "",
      exprymonth: "",
      expiryyear: "",
      expiry: "",
      cvv: "",
      autorenewal: "",
      errors: {},
      paymentmode: "direct",
      showPromoCodeField : "false",
      showPaypalButtons: false,
      showTermsModal: false
    };
    this.ccnumber = React.createRef();
    this.ccname = React.createRef();
    this.expiry = React.createRef();
    this.cvv = React.createRef();
  }

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
    if (field == 'ccnumber') {
      const cctype = getCreditCardType(value);
      if (cctype !== 'unknown') {
        this.setState({ cctype: cctype });
      }
    }
    else if (field == 'autorenewal') {
      this.setState({ autorenewal: event.target.checked ? "Y" : "" });
      //this.setState({ showTermsModal: event.target.checked });
    }
  };

  onPaymentModeChange = event => {
    this.setState({ paymentmode: event.target.value });
    this.props.setpaymentMode(event.target.value);
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }
  componentDidMount() {
    const self = this;
    function validaForms(actions) {
      if (self.props.isAddressFilled()) {
        return actions.enable();
      } else {
        return actions.disable();
      }
    }
    window.paypal.Button.render(
        {
          // Set your environment

          env: "production", // sandbox | production

          // Specify the style of the button

          style: {
            layout: "horizontal", // horizontal | vertical
            size: "responsive", // medium | large | responsive
            shape: "rect", // pill | rect
            color: "gold", // gold | blue | silver | black
            label: "paypal", // checkout | credit | pay | buynow | paypal | installment
            tagline: "false",
            fundingicons: "false"
          },

          // Specify allowed and disallowed funding sources
          //
          // Options:
          // - paypal.FUNDING.CARD
          // - paypal.FUNDING.CREDIT
          // - paypal.FUNDING.ELV

          funding: {
            allowed: [window.paypal.FUNDING.CARD],
            disallowed: []
          },

          // PayPal Client IDs - replace with your own
          // Create a PayPal app: https://developer.paypal.com/developer/applications/create

          client: {
            sandbox:
                "AZBsqKiEJ5Sq0qbnfeLEVv4HBrzyM66MKdeiZ3ZC7fi46BgSab8YInBpQQTBBCi9Krwlu8sKWfr4JFuX",
            production:
                "ARULageWmN90MKR8qElF-cXnomasjxFrvtT3nqpDT9_3LCt5w0IJis88opMAqAyEq-LgUggm3sl4Tu2U"
          },
          onClick: function(actions) {
            validaForms(actions);
          },
          payment: function(data, actions) {
            return actions.payment.create({
              payment: {
                transactions: [
                  {
                    amount: {
                      total: (parseFloat(self.props.total) + parseFloat(self.props.calculateTax())).toFixed(2),
                      currency: "USD",
                      details: {
                        shipping: self.props.cart.shippingFee,
                        //subtotal: self.props.total,
                        subtotal: self.props.subtotal,
                        tax: self.props.calculateTax()
                      }
                    },
                    description: self.getOrderComment(self.props.cart),
                    custom: self.getOrderCustom(self.props.cart)
                  }
                ]
              }
            });
          },

          onAuthorize: function(data, actions) {
            return actions.payment.execute().then(function(data) {
              console.log(data);
              self.props.handlePaypalPayment(data);
            });
          }
        },
        "#paypal-button-container"
    ).then(function() {
      self.setState({
        showPaypalButtons: true
      });
    });
  }

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  handlePayment = event => {
    event.preventDefault();
    if (this.isValid() && this.props.isHuman) {
      const { ccnumber, ccname, expiry, cvv, autorenewal } = this.state;
      const card_num = ccnumber.replace(/ +|_+/g, "");

      const extract = expiry.split("/");
      const expirymonth = extract[0];
      //const expiryyear = extract[1];
      const expiryyear = "20" + extract[1];
      const payment = {
        ccnumber,
        ccname,
        expirymonth,
        expiryyear,
        cvv,
        autorenewal,
        type: getCreditCardType(card_num)
      };
      this.props.handlePayment(payment);
    }

    //this.props.handlePayment();
  };

  setDiscountCode = e => {
    this.setState({
      discount_code : e.target.value
    })
  }

  addPromoCode = () => {
    this.setState({
      showPromoCodeField : true
    })
  }

  getOrderComment(cart) {
    var comment;

    if(cart.cartType == "device_recharge") {
      comment = `Mighty Wifi Device on recharge from ${moment(cart.startDate).format("MM/DD/YYYY")}`;
      if(cart.recurring_profile != null && cart.recurring_profile.period > 0) {
        comment += ` to ${moment(cart.startDate).add(cart.recurring_profile.period - 1, "days").format("MM/DD/YYYY")}`;
      }
    }
    else if(cart.cartType == "rent") {
      comment = `Mighty Wifi Device on rent from
        ${moment(cart.startDate).format("MM/DD/YYYY")} to
        ${moment(cart.endDate).format("MM/DD/YYYY")}`;
    }
    else if(cart.cartType == "sim") {
      comment = `Mighty Wifi SIM Card on buy from
        ${moment(cart.startDate).format("MM/DD/YYYY")} to
        ${moment(cart.endDate).format("MM/DD/YYYY")}`;
    }
    else {
      comment = `Mighty Wifi Device on buy from ${moment(cart.startDate).format("MM/DD/YYYY")}`;
      if(cart.recurring_profile != null && cart.recurring_profile.period > 0) {
        comment += ` to ${moment(cart.startDate).add(cart.recurring_profile.period - 1, "days").format("MM/DD/YYYY")}`;
      }
    }
    return comment;
  };

  getOrderCustom(cart) {
    var custom;

    /*if(cart.cartType == "device_recharge") {
      custom = `Web - Recharge`;
    }
    else if(cart.cartType == "rent") {
      custom = `Web - Rent`;
    }
    else if(cart.cartType == "sim") {
      custom = `Web - SIM`;
    }
    else {
      custom = `Web - Device`;
    }*/
    custom = cart.imei;

    return custom;
  };

  setTermsModal = (show) => {
    this.setState({
      showTermsModal : show
    });
  }

  render() {
    const { errors } = this.state;
    let { cart } = this.props;

    return (
        <div className="col-md-8 services_clip">
          <TermsModal setTermsModal={this.setTermsModal} showModal={this.state.showTermsModal}/>
          <div className="">
            <div className="row">
              <div className="col-lg-12">
                <div className="services_boxes">
                  <div className="services_content">
                    <h2 className="mb-0">Payment Method</h2>

                    <div style={{ clear: "both", height: "30px" }} />

                    <p onClick={this.addPromoCode}>Have a promo code?</p>

                    <div className="btninput">
                      <input className="form-control" name="promo_code" onChange={this.setDiscountCode} type="text"/>
                      <a className="btn" onClick={() => this.props.validateDiscount(this.state.discount_code)}>Apply</a>
                    </div>

                    {
                      (this.props.validate_discount_error !== null) ? (

                          (this.props.validate_discount_error !== true && typeof this.props.discountDetails.flatTotal !== "undefined"
                              && this.props.discountDetails.flatTotal !== null) ?
                              (
                                  <p className="center-position">Applied. Thank you</p>
                              ) : (
                                  <p className="error-text center-position" style={{color: "#cc0000"}}>Not a valid code. Please check the code again.</p>
                              )
                      ) : null
                    }

                    <div style={{ clear: "both", height: "15px" }} />
                    <form autoComplete="off">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mt-3">
                            <h4 className="mb-0 mt-2 SansSerif bold100">Credit Card</h4>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mt-3 text-left">
                            <img src="/images/logo-visa.svg" alt="" className="img-fluid credit-logo"/>
                            <img src="/images/logo-mastercard.svg" alt="" className="img-fluid credit-logo"/>
                            <img src="/images/logo-amex.svg" alt="" className="img-fluid credit-logo"/>
                            <img src="/images/logo-paypal.svg" alt="" className="img-fluid credit-logo"/>
                            <img src="/images/logo-discover.svg" alt="" className="img-fluid credit-logo"/>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mt-3 text-left">
                            <strong>Name on Card</strong>

                            <input
                                style={{ display: "none" }}
                                type="text"
                                name="fakeccname"
                            />
                            <input
                                name="ccname"
                                ref={this.ccname}
                                onChange={this._onChange}
                                className="form-control"
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="off"
                            />
                            {errors.ccname && (
                                <span className="error-color">{errors.ccname}</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mt-3 text-left">
                            <strong>Credit Card Number</strong>
                            <input
                                style={{ display: "none" }}
                                type="text"
                                name="fakeccnumber"
                            />
                            {/*<InputMask
                            mask="9999 9999 9999 9999"
                            ref={this.ccnumber}
                            name="ccnumber"
                            className="form-control"
                            maskChar={null}
                            onChange={this._onChange}
                            autoComplete="off"
                            autoCorrect="off"
                            spellCheck="off"
                          />*/}
                            <MaskedInput
                                mask={this.state.cctype == 'amex' ? [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
                                ref={this.ccnumber}
                                name="ccnumber"
                                className="form-control"
                                maskChar={null}
                                onChange={this._onChange}
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="off"
                            />
                            {errors.ccnumber && (
                                <span className="error-color">
                              {errors.ccnumber}
                            </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group mt-3 text-left">
                            <strong>Expiration Date</strong>
                            <input
                                style={{ display: "none" }}
                                type="text"
                                name="fakeexpiry"
                            />
                            {/*<InputMask
                            mask="99/99"
                            placeholder="MM/YY"
                            ref={this.expiry}
                            name="expiry"
                            className="form-control"
                            maskChar={null}
                            onChange={this._onChange}
                            autoComplete="new-password"
                            autoCorrect="off"
                            spellCheck="off"
                          />*/}
                            <MaskedInput
                                mask="99/99"
                                mask={[/\d/, /\d/, '/', /\d/, /\d/]}
                                placeholder="MM/YY"
                                ref={this.expiry}
                                name="expiry"
                                className="form-control"
                                maskChar={null}
                                onChange={this._onChange}
                                autoComplete="new-password"
                                autoCorrect="off"
                                spellCheck="off"
                            />
                            {errors.expiry && (
                                <span className="error-color">{errors.expiry}</span>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group mt-3 text-left">
                            <strong>CVV Code</strong>
                            <input
                                id="myInput"
                                style={{ display: "none" }}
                                type="password"
                                name="fakepasswordremembered"
                            />
                            {/*<InputMask
                            id="myInput"
                            mask="9999"
                            type="password"
                            ref={this.cvv}
                            name="cvv"
                            className="form-control"
                            maskChar={null}
                            onChange={this._onChange}
                            autoComplete="new-password"
                            autoCorrect="off"
                            spellCheck="off"
                          />*/}
                            <MaskedInput
                                id="myInput"
                                mask={this.state.cctype == 'amex' ? [/\d/, /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/]}
                                type="password"
                                ref={this.cvv}
                                name="cvv"
                                className="form-control"
                                maskChar={null}
                                onChange={this._onChange}
                                autoComplete="new-password"
                                autoCorrect="off"
                                spellCheck="off"
                            />
                            {errors.cvv && (
                                <span className="error-color">{errors.cvv}</span>
                            )}
                          </div>
                        </div>
                      </div>

                      {
                        (cart.cartType === 'device_recharge' && cart.useType === "USA" && cart.associated_product.type === 'data_package') ? (

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group mt-3 text-left">
                          <div>
                            <label><strong>Auto Pay</strong></label>
                            <input
                                type="checkbox"
                                name="autorenewal"
                                className="form-check-input"
                                style={{ marginLeft: "10px", width: "1.2em", height: "1.2em" }}
                                value="Y"
                                onChange={this._onChange}
                            />
                            <span style={{marginLeft: "45px", textDecoration: "underline"}}><strong>Save 5% starting from your next auto payment</strong></span>
                          </div>
                          <div>By checking the auto pay, I have read and agree to the terms and conditions of auto pay.</div>
                          <div>Click the link to review Terms and Conditions.</div>
                          <div style={{ clear: "both", height: "30px" }} />
                          <div><a href="javascript:void(0)" onClick={() => this.setTermsModal(true)}>See terms and conditions</a></div>
                        </div>
                      </div>
                    </div>

                        ) : null
                      }

                      <div style={{ clear: "both", height: "30px" }} />

                      <div className="row">
                        <div className="col-lg-6">
                          <ReCAPTCHA
                              ref={this.props.recaptchaRef}
                              sitekey={'6LdUIyweAAAAAOs44Nk0ouoOHyz1YlbNMCJuBHfo'}
                              // render="explicit"
                              onChange={this.props.verifyCaptcha}
                              onExpired={this.props.expireCaptcha}
                          />
                        </div>
                      </div>

                      <div style={{ clear: "both", height: "30px" }} />

                      <div className="row">
                        <div className="col-lg-6">
                          <a
                              href="javascript:void(0)"
                              onClick={this.goBack}
                              className="btn btn-white mr-15"
                          >
                            Back
                          </a>
                        </div>
                      </div>

                      { !this.props.isProcessing && this.props.isHuman ?
                          (
                              <div className="row" style={{ paddingTop: "10px" }}>
                                <div className="col-lg-6">
                                  <a
                                      href="javascript:void(0)"
                                      onClick={this.handlePayment}
                                      className="btn btn-orange"
                                      style={{ width: "100%"}}
                                  >
                                    SUBMIT
                                  </a>
                                </div>
                              </div>
                          ) : null
                      }

                      <div style={{ clear: "both", height: "80px" }} />

                      <div className="row">
                        <div className="col-lg-12">
                          <h4 className="mb-20 mt-2 SansSerif bold100"><strong>or</strong> PayPal Payment</h4>
                        </div>

                        <div className="col-lg-6">
                          <span id="paypal-button-container"/>
                        </div>
                      </div>

                      <div style={{ clear: "both", height: "80px" }} />

                      {/*<div style={{ clear: "both", height: "30px" }} />

                    <a
                        href="javascript:void(0)"
                        onClick={this.goBack}
                        className="btn btn-outline-white"
                    >
                      Back
                    </a>

                    { !this.props.isProcessing ?

                        (

                    <a
                        style={{marginLeft:"22%"}}
                      href="javascript:void(0)"
                      onClick={this.handlePayment}
                      className="btn btn-outline-white"
                    >
                      CONTINUE
                    </a>

                        ) : null
                    }*/}

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(PaymentMethod);



// WEBPACK FOOTER //
// ./src/pages/rechargeCheckout/PaymentMethod.js